import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox, Pagination, Table, Collapse, Modal } from 'antd';
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import loginlogo from 'src/assets/images/loginlogo.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { UserOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { setPermissions, resetPermissions } from '../../../actions';
import { apiUrls } from '../../../apiUrls.js';
import DatePicker, { utils } from '@hassanmojab/react-modern-calendar-datepicker';
const { Option } = Select;

const Login = () => {

  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingCheckLive, setLoadingCheckLive] = useState(true);
  const [phoneNumberForRecoverAccount, setPhoneNumberForRecoverAccount] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [birthDay, setBirthDay] = useState(null);
  const baseIdentityURL = apiUrls.baseIdentityURL;
  const baseURL = apiUrls.baseURL;
  const dispatch = useDispatch();
  const [guestModel, setGuestModel] = useState({});
  const [isShowCreateGuestModalVisible, setIsShowCreateGuestModalVisible] = useState(false);
  const [isShowRecoverPasswordModalVisible, setIsRecoverPasswordModalVisible] = useState(false);
  const [loadingCreateGuest, setLoadingCreateGuest] = useState(false);
  const [loadingRecoverPassword, setLoadingRecoverPassword] = useState(false);
  const [dropDownEducations, setDropDownEducations] = useState([]);
  const [dropDownGenders, setDropDownGenders] = useState([]);

  dispatch(resetPermissions());

  useEffect(() => {
    checkLive()
    fetchEducations()
    fetchGenders()
  }, [])

  const checkLive = async () => {
    const token = localStorage.getItem('damavandclub-token')
    
      axios.get(`${baseURL}/user/getPermissions`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        dispatch(resetPermissions());
        dispatch(setPermissions(response.data.data));
        navigate('/dashboard');
        setLoadingCheckLive(false)
      }).catch(()=>{
        setLoadingCheckLive(false)
      }) 
  }

  const setSelectedBirthDay = async (date) => {
    setBirthDay({
      year: date.year,
      month: date.month,
      day: date.day
    });
    setGuestModel({ ...guestModel, birthDay: `${date.year}/${date.month}/${date.day}` })
  }

  const recoverPassword = async () => {

    const phoneNumberRegex = /^[0-9]{11}$/;

    setLoadingRecoverPassword(true)

    if (!phoneNumberRegex.test(phoneNumberForRecoverAccount))
      return toast.warning('شماره همراه صحیح نیست!', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });

    const token = localStorage.getItem('damavandclub-token')

    try {
      await axios.get(`${baseURL}/user/recoverpassword?phonenumber=${phoneNumberForRecoverAccount}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      toast.success('با موفقیت ارسال شد', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });
      setLoadingRecoverPassword(false);
      setIsRecoverPasswordModalVisible(false)
    } catch (error) {
      if (error.response.status == 401)
        return navigate('/');
      setIsRecoverPasswordModalVisible(false)
      toast.error(error.response.data.Msg, {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });
      setLoadingRecoverPassword(false);
    } finally {
      setLoadingRecoverPassword(false);
    }
  }

  const createGuest = async () => {

    const phoneNumberRegex = /^[0-9]{11}$/;
    const nationalCodeRegex = /^[0-9]{10}$/;

    if (guestModel.firstName == null)
      return toast.warning('نام وارد نشده است!', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });

    if (guestModel.lastName == null)
      return toast.warning('نام خانوادگی وارد نشده است!', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });

    if (!phoneNumberRegex.test(guestModel.phoneNumber))
      return toast.warning('شماره همراه صحیح نیست!', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });

    if (!nationalCodeRegex.test(guestModel.nationalCode))
      return toast.warning('کد ملی صحیح نیست!', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });

    if (birthDay == null)
      return toast.warning('تاریخ تولد وارد نشده است!', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });

    if (guestModel.educationLevel == null)
      return toast.warning('تحصیلات انتخاب نشده است!', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });

    if (guestModel.gender == null)
      return toast.warning('جنسیت انتخاب نشده است!', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });

    const token = localStorage.getItem('damavandclub-token')

    setLoadingCreateGuest(true);

    try {
      await axios.post(`${baseURL}/user/createguest`, guestModel, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      toast.success('ثبت نام انجام شد اکانت ورود به پرتال به شماره همراه شما ارسال شد', {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });
      setLoadingCreateGuest(false);
      setIsShowCreateGuestModalVisible(false)
    } catch (error) {
      if (error.response.status == 401)
        return navigate('/');
      setIsShowCreateGuestModalVisible(false)
      toast.error(error.response.data.Msg, {
        position: 'bottom-right',
        autoClose: 6000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        //className: 'custom-toast',
        pauseOnHover: true,
        draggable: true,
      });
      setLoadingCreateGuest(false);
    } finally {
      setLoadingCreateGuest(false);
    }
  }

  const fetchEducations = async () => {
    const token = localStorage.getItem('damavandclub-token')
    try {
      const response = await axios.get(`${baseURL}/user/getEducationLevelDropdownItems`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })

      var result = response.data.data;
      setDropDownEducations(result);
    } catch (error) {
    } finally {
    }
  };

  const fetchGenders = async () => {
    const token = localStorage.getItem('damavandclub-token')
    try {
      const response = await axios.get(`${baseURL}/user/getGenderDropdownItems`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })
      var result = response.data.data;
      setDropDownGenders(result);
    } catch (error) {
    } finally {
    }
  };

  const login = async () => {
    setLoadingLogin(true);
    try {
      const response = await axios.post(`${baseIdentityURL}/security/login`, {
        username: username,
        password: password,
      });

      localStorage.setItem('damavandclub-token', response.data.access_token);
      localStorage.setItem('damavandclub-fullname', response.data.fullName);
      localStorage.setItem('damavandclub-membertype', response.data.memberType);
      localStorage.setItem('damavandclub-profilephotourl', response.data.profilePhotoUrl);

      axios.get(`${baseURL}/user/getPermissions`, {
        headers: {
          'Authorization': `Bearer ${response.data.access_token}`,
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        dispatch(setPermissions(response.data.data));
      })

      toast.success("به پرتال باشگاه دماوند خوش آمدید", {
        position: 'bottom-right',
        autoClose: 3000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        //className: 'custom-toast',
        draggable: true,
      });
      setLoadingLogin(false);
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response.data.Msg, {
        position: 'bottom-right',
        autoClose: 3000, // milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        //className: 'custom-toast',
        draggable: true,
      });
      setLoadingLogin(false);
    } finally {
      setLoadingLogin(false);
    }
  };

  if (loadingCheckLive)
    return (
      <div style={{
        flexDirection: 'column',
        backgroundColor: '#afddf5',
        display: 'flex',
        justifyContent: 'center',
        minHeight: '100vh',
        alignContent: 'center',
        alignItems: 'center'
      }}>
        <img
          style={{
            borderRadius: 150 / 2,
            overflow: 'hidden',
            borderWidth: 3,
          }}
          width={300}
          height={300}
          src={loginlogo}
        ></img>
      </div>
    )

  return (
    <div style={{
      flexDirection: 'column',
      backgroundColor: '#afddf5',
      display: 'flex',
      justifyContent: 'center',
      minHeight: '100vh',
      alignContent: 'center',
      alignItems: 'center'
    }}>
      <img
        style={{
          borderRadius: 150 / 2,
          overflow: 'hidden',
          borderWidth: 3,
        }}
        width={300}
        height={300}
        src={loginlogo}
      ></img>

      <div style={{
        display: 'flex',
        width: 340,
        height: 330,
        flexDirection: 'column',
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: 20,
        justifyContent: 'center'
      }}>

        <label>نام کاربری</label>
        <Input onChange={(event) => setUsername(event.target.value)} style={{ marginTop: 5 }} size="large" />

        <label>رمز عبور</label>
        <Input onChange={(event) => setPassword(event.target.value)} style={{ marginTop: 5 }} type='password' size="large" />

        <Button onClick={() => login()} loading={loadingLogin} style={{ backgroundColor: 'rgb(0, 71, 177)', marginTop: 10, width: '100%', marginBottom: 10 }}
          type="primary"><label>ورود</label></Button>

        <Button onClick={() => {
          setGuestModel({})
          setIsShowCreateGuestModalVisible(true)
        }} style={{ backgroundColor: 'rgb(0, 71, 177)', width: '100%' }} type="primary"><label>ثبت نام اعضای مهمان</label></Button>

        <a className="margin-top txt-center margintop-10" style={{ color: 'green', textAlign: 'center' }} target="_blank" rel="noopener noreferrer" href="https://wa.me/989181604132">
          تماس با بخش فنی <FontAwesomeIcon icon={faWhatsapp} size="2x" /></a>

        <i className="fa-brands fa-whatsapp"></i>

        <a className="margintop-10 center red" onClick={() => setIsRecoverPasswordModalVisible(true)}>فراموشی یا دریافت رمز عبور
        </a>

      </div>


      <a referrerpolicy='origin' href='https://trustseal.enamad.ir/?id=517599&Code=qqHWPSaO71k3d3PlPyw7BeVFbEWYUBzJ'>
        <img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=517599&Code=qqHWPSaO71k3d3PlPyw7BeVFbEWYUBzJ'
          alt='' style={{ cursor: 'pointer', width: 50, height: 50 }} ></img></a>

      <Modal
        title={`ثبت نام عضو مهمان`}
        open={isShowCreateGuestModalVisible}
        width={500}
        closable={false}
        okButtonProps={null}
        footer={<div className='row-container'>
          <Button onClick={() => {
            setBirthDay(null)
            setGuestModel({})
            setIsShowCreateGuestModalVisible(false)
          }} style={{ width: '100%' }}>بستن</Button>
          <Button type="primary" loading={loadingCreateGuest}
            onClick={() => createGuest()}
            style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>ثبت نام</Button>
        </div>}
      >
        <label>نام</label>
        <Input value={guestModel.firstName} onChange={(event) => setGuestModel({ ...guestModel, firstName: event.target.value })} style={{ marginTop: 5 }} size="large" />

        <label className='margintop-7'>نام خانوادگی</label>
        <Input value={guestModel.lastName} onChange={(event) => setGuestModel({ ...guestModel, lastName: event.target.value })} style={{ marginTop: 5 }} size="large" />

        <label className='margintop-7'>شماره همراه (اعداد انگلیسی)</label>
        <Input type='number' inputmode="numeric" value={guestModel.phoneNumber}
          onChange={(event) => setGuestModel({ ...guestModel, phoneNumber: event.target.value })}
          style={{ marginTop: 5, textAlign: 'right' }} size="large" />

        <label className='margintop-7'>کد ملی (اعداد انگلیسی)</label>
        <Input type='number' inputmode="numeric" value={guestModel.nationalCode}
          onChange={(event) => setGuestModel({ ...guestModel, nationalCode: event.target.value })}
          style={{ marginTop: 5, textAlign: 'right' }}
          size="large" />

        <label className='margintop-7'>تاریخ تولد</label>
        <div className='margintop-7 center-content customDatePickerWidth'>
          <DatePicker
            value={birthDay || null}
            //inputClassName='fullwidth'
            onChange={(value) => setSelectedBirthDay(value)}
            //minimumDate={persianToday}
            //calendarClassName="fullwidth"
            shouldHighlightWeekends
            locale='fa'
          />
        </div>
        <label className='margintop-7'>تحصیلات</label>
        <Select
          style={{ width: '100%', marginTop: 7 }}
          placeholder="انتخاب سطح تحصیلات"
          onChange={(value) => setGuestModel({ ...guestModel, educationLevel: value })}
          value={guestModel.educationLevel}
        >
          {dropDownEducations?.map((item) => (
            <Option key={item.id} value={item.id}>
              {item.displayName}
            </Option>
          ))}
        </Select>
        <label className='margintop-7'>جنسیت</label>
        <Select
          style={{ width: '100%', marginTop: 7 }}
          placeholder="انتخاب جنسیت"
          onChange={(value) => setGuestModel({ ...guestModel, gender: value })}
          value={guestModel.gender}
        >
          {dropDownGenders?.map((item) => (
            <Option key={item.id} value={item.id}>
              {item.displayName}
            </Option>
          ))}
        </Select>

      </Modal>
      <Modal
        title={`دریافت اکانت ورود`}
        open={isShowRecoverPasswordModalVisible}
        width={500}
        closable={false}
        okButtonProps={null}
        footer={<div className='row-container'>
          <Button onClick={() => {
            setIsRecoverPasswordModalVisible(false)
          }} style={{ width: '100%' }}>بستن</Button>
          <Button type="primary" loading={loadingRecoverPassword}
            onClick={() => recoverPassword()}
            style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>تایید</Button>
        </div>}
      >
        <label className='margintop-7'>شماره همراه (اعداد انگلیسی)</label>
        <Input type='number' inputmode="numeric" value={phoneNumberForRecoverAccount}
          onChange={(event) => setPhoneNumberForRecoverAccount(event.target.value)}
          style={{ marginTop: 5, textAlign: 'right' }} size="large" />

      </Modal>
    </div>
  )
}

export default Login
